export default __webpack_public_path__ + "static/media/lightArrow.4033cec2.svg";